import { render, staticRenderFns } from "./TdxNavigationLink.vue?vue&type=template&id=9da15da2&scoped=true&"
import script from "./TdxNavigationLink.vue?vue&type=script&lang=js&"
export * from "./TdxNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./TdxNavigationLink.vue?vue&type=style&index=0&id=9da15da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da15da2",
  null
  
)

export default component.exports